export default "__VITE_ASSET__CTzFiEIk__"